interface FeatureCard {
  icon: string;
  title: string;
  description: string;
}

const features: FeatureCard[] = [
  {
    icon: 'ri-rocket-line',
    title: 'Faster Product Discovery',
    description: 'Find products organized by categories instead of browsing randomly. Every spreadsheet is structured for quick scanning so you can locate what matters in seconds.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Better Shopping Decisions',
    description: 'Compare products, prices, quality information and buyer recommendations side by side. Our comparison framework helps you evaluate options with clarity and confidence.',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Beginner Friendly',
    description: 'Simple guides designed for first-time international shoppers. No confusing jargon, just straightforward help that walks you through every step of the process.',
  },
  {
    icon: 'ri-refresh-line',
    title: 'Updated Research',
    description: 'Regularly updated resources covering trending products and emerging categories. You will always find fresh content that reflects the latest shopping landscape.',
  },
];

export default function FeatureCards() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-3">
            Why Choose Us
          </p>
          <h2 className="section-title mb-3">
            Why Thousands Of Shoppers Use SuperBuy Spreadsheet
          </h2>
          <p className="section-subtitle mx-auto">
            Built for efficiency, designed for clarity. Here is what makes our resource platform different.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="card-base p-6 md:p-7 group hover:border-foreground-200"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-500 group-hover:text-primary-600 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="font-body text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}